import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

export const Seo = ({ title, description, pathname, children }) => {
  const { title: defaultTitle, description: defaultDescription, siteUrl } = useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname || ``}`,
  }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content="https://s3.amazonaws.com/cdn2-cloud66-com/images/ogimage.png" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content="https://s3.amazonaws.com/cdn2-cloud66-com/images/ogimage.png" />
      <meta name="twitter:creator" content="@cloud66" />

      <meta property="og:title" content={seo.title} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:image" content="https://s3.amazonaws.com/cdn2-cloud66-com/images/ogimage.png" />
      <meta property="og:description" content={seo.description} />
      <meta property="og:site_name" content="Cloud 66" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:type" content="website" />
      <meta property="og:logo" content="https://s3.amazonaws.com/cdn2-cloud66-com/images/cloud66_128.png" />
      <meta name="ahrefs-site-verification" content="f4a43ed66a49ae3bb4988c25e6ee1c363306bc1ef765eb2f5c24416e4ff3a428" />

      {children}
    </>
  )
}
